module.exports = __webpack_public_path__ + "img/ico_award.66ff058c.svg";